import {serializable, alias, primitive, object} from 'serializr';
import {ClassRoomSubjectModel, SubjectModel} from "../SubjectModel/subject.model";

export class ChapterModel{
    @serializable(alias('id', primitive()))
    id?: string;
    @serializable(alias('name', primitive()))
    name?: string;
    @serializable(alias('is_active', primitive()))
    isActive?: boolean;
    @serializable(alias('position', primitive()))
    position?: string;
    @serializable(alias('class_room_subject', object(ClassRoomSubjectModel)))
    classroomSubject?: string;
}
